import { E as EMPTY_VALUES } from './constants.js';
import { c as checkOneOf } from './check-one-of.js';
import { c as checkType } from './check-type.js';

function emptyOr(check) {
    return (...args) => {
        const value = args[0];
        if (!EMPTY_VALUES.some(v => v === value))
            check(...args);
    };
}

function checkPattern(value, pattern, errorMessage) {
    if (typeof value !== 'string' || !pattern.test(value))
        throw new Error(errorMessage);
}

function checkUrl(value, error) {
    if (typeof value !== 'string' && !(value instanceof URL))
        throw new Error(error);
    try {
        new URL(value);
    }
    catch (e) {
        throw new Error(error);
    }
}

const checkEmptyOrOneOf = emptyOr(checkOneOf);
const checkEmptyOrPattern = emptyOr(checkPattern);
const checkEmptyOrType = emptyOr(checkType);
const checkEmptyOrUrl = emptyOr(checkUrl);

export { checkEmptyOrOneOf as a, checkEmptyOrPattern as b, checkEmptyOrType as c, checkEmptyOrUrl as d };
